// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"b07f5160","408":"a3fc8d71"}[chunkId] + ".chunk.js";
};